/**
 * Newsletter Subscription Module
 * Gère le formulaire de newsletter avec AJAX
 */

export function initNewsletterForm() {
    const form = document.getElementById('newsletter-form');
    const messageDiv = document.getElementById('newsletter-message');
    const emailInput = document.getElementById('newsletter_email');
    const submitButton = form?.querySelector('button[type="submit"]');

    if (!form) return;

    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Validation basique
        const email = emailInput.value.trim();
        if (!email) {
            showMessage('Veuillez saisir une adresse email.', 'error');
            return;
        }

        if (!isValidEmail(email)) {
            showMessage('Veuillez saisir une adresse email valide.', 'error');
            return;
        }

        // Disable form during submission
        setFormLoading(true);

        try {
            const formData = new FormData(form);
            
            // Utiliser l'URL AJAX relative qui fonctionne toujours sur WordPress
            const ajaxUrl = '/wp-admin/admin-ajax.php';
            
            const response = await fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.success) {
                showMessage(result.data.message, 'success');
                form.reset(); // Reset form on success
            } else {
                showMessage(result.data.message || 'Une erreur est survenue.', 'error');
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            showMessage('Une erreur réseau est survenue. Veuillez réessayer.', 'error');
        } finally {
            setFormLoading(false);
        }
    });

    /**
     * Show message to user
     */
    function showMessage(message, type) {
        if (!messageDiv) return;

        messageDiv.className = `mt-4 text-sm ${type === 'success' ? 'text-green-100' : 'text-red-100'}`;
        messageDiv.textContent = message;
        messageDiv.classList.remove('hidden');

        // Auto hide after 5 seconds for success messages
        if (type === 'success') {
            setTimeout(() => {
                messageDiv.classList.add('hidden');
            }, 5000);
        }
    }

    /**
     * Set form loading state
     */
    function setFormLoading(loading) {
        if (!submitButton) return;

        if (loading) {
            submitButton.disabled = true;
            submitButton.textContent = 'Envoi...';
            submitButton.classList.add('opacity-75', 'cursor-not-allowed');
        } else {
            submitButton.disabled = false;
            submitButton.textContent = 'Envoyer';
            submitButton.classList.remove('opacity-75', 'cursor-not-allowed');
        }
    }

    /**
     * Validate email format
     */
    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    console.log('✅ Newsletter form initialized');
}
